import { render } from "./MfaVerify.vue?vue&type=template&id=61fd06de"
import script from "./MfaVerify.vue?vue&type=script&lang=js"
export * from "./MfaVerify.vue?vue&type=script&lang=js"

import "@/assets/css/auth.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__